import moment from 'moment';
import { EMPLOYEE_CONTACT_TYPES } from 'constants/companies';

// form rows are fixed per contact type, so place contacts by contact_type, not by array index
const getContactsByFormRow = (contacts) => {
  const rows = EMPLOYEE_CONTACT_TYPES.map(({ value }) =>
    contacts.find((c) => c.contact_type === value),
  );
  contacts
    .filter((c) => !rows.includes(c))
    .forEach((c) => {
      const freeIndex = rows.findIndex((r) => !r);
      if (freeIndex !== -1) {
        rows[freeIndex] = c;
      }
    });
  return rows;
};

export const prepareData = (item = {}) => {
  const data = {
    company_employee_contacts_attributes: '',
    title: '',
    nego_id: '',
    vat: '',
    place_area: '',
    opening_date: null,
    closing_date: null,
    contract_start_date: null,
    contract_end_date: null,
    location_code: '',
    food: true,
    shopping_center_id: '',
    chain_id: '',
    category_id: '',
    company_child_category_id: '',
    commodity_category: '',
    company_category_id: '',
    prestige_level_id: '',
    send_monthly_invoice_reminder: true,
    exclude_reminder_notification: false,
    invoice_year_type: '',
    'company_data_attributes.address_address': '',
    'company_data_attributes.address_city': '',
    'company_data_attributes.address_denominazione': '',
    'company_data_attributes.address_postal_code': '',
    'company_data_attributes.address_province': '',
    'company_data_attributes.address_tax_code': '',
    'company_data_attributes.address_unique_code': '',
    'company_data_attributes.email': '',
    'company_data_attributes.gift_cards': '',
    'company_data_attributes.insert_link': '',
    'company_data_attributes.number_full_time_employees': '',
    'company_data_attributes.number_part_time_employees': '',
    'company_data_attributes.one_day_card': '',
    'company_data_attributes.payment_accept': false,
    'company_data_attributes.payment_alipay': false,
    'company_data_attributes.payment_american_express': '',
    'company_data_attributes.payment_apple_pay': false,
    'company_data_attributes.payment_mastercard': '',
    'company_data_attributes.payment_paypal': false,
    'company_data_attributes.payment_poste_pay': '',
    'company_data_attributes.payment_satispay': '',
    'company_data_attributes.payment_union_pay': false,
    'company_data_attributes.payment_visa': false,
    'company_data_attributes.payment_scalapay': false,
    'company_data_attributes.payment_klarna': false,
    'company_data_attributes.payment_wechat_pay': '',
    'company_data_attributes.pec_aziendale': '',
    'company_data_attributes.phone': '',
    'company_data_attributes.tax_free': '',
    'company_data_attributes.village_contract': '',
    'company_data_attributes.whatsapp': '',
    'company_data_attributes.whatsapp2': '',
    'company_data_attributes.whatsapp3': '',

    'company_click_collect_attributes.is_click_collect': false,
    'company_click_collect_attributes.is_click_reserve': false,
    'company_click_collect_attributes.is_online_shop': false,
    'company_click_collect_attributes.macro_category': '',
    'company_click_collect_attributes.product_sheet_model': '',
    'company_click_collect_attributes.products_limit': '',
    'company_click_collect_attributes.date_begin': '',
    'company_click_collect_attributes.date_end': '',
    'company_click_collect_attributes.backend_access_click_collect': false,
    'company_click_collect_attributes.view_online_click_collect': false,
    'company_click_collect_attributes.is_whatsapp': false,
    'company_click_collect_attributes.company': '',
    'company_click_collect_attributes.return_product': '',
    'company_click_collect_attributes.change_product': '',
    'company_click_collect_attributes.guarantee_product': '',
    'company_click_collect_attributes.shop_policy_click_collect': '',
    'company_click_collect_attributes.delivery_type': '',
    'company_click_collect_attributes.delivery_type_box': false,
    'company_click_collect_attributes.delivery_type_table': false,
    'company_click_collect_attributes.delivery_box_price': '',
    'company_click_collect_attributes.email_support': '',

    'company_click_collect_attributes.return_type': '',
    'company_click_collect_attributes.return_box_price': '',
    company_table_prices_attributes: [],
    'company_competitors.0': '',
    'company_competitors.1': '',
    'company_click_collect_attributes.dev_mode': false,
    'company_click_collect_attributes.api_key': '',
    'company_click_collect_attributes.shop_login': '',
  };

  if (item.id) {
    Object.keys(data).forEach((key) => {
      const [f, s] = key.split('.');
      if (key === 'company_employee_contacts_attributes') {
        const company_employee_contacts = getContactsByFormRow(
          item?.company_employee_contacts || [],
        );
        company_employee_contacts.forEach((i, index) => {
          if (!i) {
            return;
          }
          data[`company_employee_contacts_attributes.surname.${index}`] =
            i.surname;
          data[`company_employee_contacts_attributes.name.${index}`] = i.name;
          data[`company_employee_contacts_attributes.phone.${index}`] = i.phone;
          data[`company_employee_contacts_attributes.email.${index}`] = i.email;
          data[`company_employee_contacts_attributes.id.${index}`] = i.id;
        });
        return;
      }
      if (key === 'company_table_prices_attributes') {
        const company_employee_contacts =
          item?.company_click_collect?.company_table_prices || [];
        const keys = [
          'to_30',
          'from_30_to_50',
          'from_50_to_100',
          'from_100_to_150',
          'from_150_to_200',
          'from_200_to_250',
          'from_250',
        ];
        company_employee_contacts.map((i, index) => {
          keys.forEach((key) => {
            data[
              `company_click_collect_attributes.company_table_prices.${index}.${key}`
            ] = i[key];
          });
        });
        return;
      }

      if (typeof item.exclude_reminder_notification !== 'undefined') {
        data.exclude_reminder_notification = item.exclude_reminder_notification;
      }

      if (s) {
        const fKey = f.replace('_attributes', '');
        switch (key) {
          case 'company_employee_contacts_attributes.surname.1':
          case 'company_employee_contacts_attributes.phone.1':
          case 'company_employee_contacts_attributes.email.1':
          case 'company_employee_contacts_attributes.name.1':
          case 'company_employee_contacts_attributes.surname.0':
          case 'company_employee_contacts_attributes.phone.0':
          case 'company_employee_contacts_attributes.email.0':
          case 'company_employee_contacts_attributes.name.0': {
            const index = key.split('.').pop();
            const param = key.split('.')[1];
            data[key] = data[key] =
              item.company_employee_contacts &&
              item.company_employee_contacts[index] &&
              item.company_employee_contacts[index][param];
            return;
          }
          case 'company_competitors.1': {
            data[key] =
              item.company_competitors &&
              item.company_competitors[1] &&
              item.company_competitors[1].competior &&
              item.company_competitors[1].competior.id;
            return;
          }
          case 'company_competitors.0': {
            data[key] =
              item.company_competitors &&
              item.company_competitors[0] &&
              item.company_competitors[0].competior &&
              item.company_competitors[0].competior?.id;
            return;
          }
          case 'company_click_collect_attributes.date_end':
          case 'company_click_collect_attributes.date_begin': {
            if (item[fKey]) {
              data[key] = moment(item[fKey][s]).isValid()
                ? moment(item[fKey][s])
                : null;
            }
            return;
          }
          default:
            break;
        }
        if (item[fKey] && item[fKey][s]) {
          data[key] = item[fKey][s];
        }
      } else {
        const isId = key.split('_id').length > 1;
        if (key === 'nego_id') {
          data[key] = item[key];
          return;
        }

        if (isId) {
          data[key] = item[key.replace('_id', '')]?.id || '';
        } else {
          const isDate = key.split('_date').length > 1;
          data[key] = isDate
            ? moment(item[key]).isValid()
              ? moment(item[key])
              : null
            : item[key] ?? '';
        }
      }
    });
  }

  return data;
};
